var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spot"},[_c('div',{staticClass:"text watch",class:{
    'activate': _vm.trackTime >= 14.0,
    'fade': _vm.trackTime >= 14.75
  }},[_vm._v("Watch")]),_c('div',{staticClass:"small-tv",class:{
    'activate': _vm.trackTime >= 14.75,
    'move': _vm.trackTime >= 15
  }}),_c('div',{staticClass:"text K",class:{
    'activate': _vm.trackTime >= 15.25,
    'move': _vm.trackTime >= 15.75
  }},[_vm._v("K")]),_c('div',{staticClass:"text W",class:{
    'activate': _vm.trackTime >= 15.85,
    'move': _vm.trackTime >= 16.25
  }},[_vm._v("W")]),_c('div',{staticClass:"text E",class:{
    'activate': _vm.trackTime >= 16.35,
    'move': _vm.trackTime >= 16.75
  }},[_vm._v("E")]),_c('div',{staticClass:"text T",class:{
    'activate': _vm.trackTime >= 16.85,
     'move': _vm.trackTime >= 17.25
  }},[_vm._v("T")]),_c('div',{staticClass:"text V",class:{
    'activate': _vm.trackTime >= 17.35,
     'move': _vm.trackTime >= 18
  }},[_vm._v("V")]),_c('div',{staticClass:"TV-text",class:{
    'activate': _vm.trackTime >= 18.25,
    'move': _vm.trackTime >= 19
  }},[_vm._v("KWETV")]),_c('p',{staticClass:"here",class:{
    'activate': _vm.trackTime >= 19,
    'move': _vm.trackTime >= 19.5
  }},[_vm._v("We are here for you!")])])}
var staticRenderFns = []

export { render, staticRenderFns }